export enum EquipmentBreadCrumb {
  BREADCRUMS_OFF = 1,
  BREADCRUM_ONLY = 2,
  BREADCRUMS_AND_LINES = 3
}
